import { LazyAction, LazyModule } from 'owa-bundling';

import ReadWriteRecipientViewState from './store/schema/ReadWriteRecipientViewState';
export { ReadWriteRecipientViewState };

import ReadWriteRecipientWellViewState from './store/schema/ReadWriteRecipientWellViewState';
export { ReadWriteRecipientWellViewState };

import RecipientWellWithFindControlViewState from './store/schema/RecipientWellWithFindControlViewState';
export { RecipientWellWithFindControlViewState };

import FindRecipientPersonaType from './store/schema/FindRecipientPersonaType';
export { FindRecipientPersonaType };

import { RecipientType } from './store/schema/RecipientType';
export { RecipientType };

export { RecipientExpansionStatus } from './store/schema/RecipientExpansionStatus';
export { RecipientMemberInfo } from './store/schema/RecipientMemberInfo';
const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "RecipientCommon" */ './lazyIndex')
);

export const lazySetMembersToRecipientViewState = new LazyAction(
    lazyModule,
    m => m.setMembersToRecipientViewState
);

export const lazySetRecipientExpansionStatus = new LazyAction(
    lazyModule,
    m => m.setRecipientExpansionStatus
);
